import { useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import './action-button.scss';
import { ClickAwayListener } from '@mui/material';

// action button
interface Props {
    disable: boolean;
    list?: any;
    selectedItem?: any;
}
const ActionBtn = (props: Props) => {
    const { disable, list, selectedItem } = props;
    const [btnDropDown, setBtnDropDown] = useState(false);

    return (
        <ClickAwayListener onClickAway={() => setBtnDropDown(false)}>
            <div className="action-btn-wrapper">
                <button className={`btn action-btn text-capitalize ${disable ? 'btn-disabled' : 'btn-primary'}`}
                    onClick={() => setBtnDropDown(!btnDropDown)}>
                    <span>actions</span>
                    <ArrowDropDownIcon sx={{ ml: 2 }} />
                </button>
                {btnDropDown && <div className="btn-drop-down">
                    <ul className='list'>
                        {list.map((item: any) =>
                            <li className='list-item cursor-pointer' key={item}
                                onClick={() => { selectedItem(item); setBtnDropDown(false) }}>{item}</li>)}
                    </ul>
                </div>}
            </div>
        </ClickAwayListener>
    )
}
export default ActionBtn